import React, { useCallback, useState } from 'react';
import LayersHeading from 'components/customComponents/Layers/LayersHeading';
import { ReactComponent as AddIngredient } from 'Icons/Sidebar/AddIngredient.svg';
import { ReactComponent as Edit } from 'Icons/CommandPanel/Edit.svg';
import { ReactComponent as Delete } from 'Icons/CommandPanel/Delete.svg';
import { RandomLayerExcludeIngredientCard } from 'components/customComponents/Layers/InputGroups';
import ELayersView from 'enums/ELayersView';
import { RandomLayerExcludeIngredientProps } from 'business/models/CustomModels';
import {
  LayerDTO,
  RandomLayerDTO,
  RandomLayerExcludeListDTO,
} from 'business/models/Models';
import { usePreserveExperiment, useRMDispatch, useRMSelector } from 'redux/hooks';
import { showSnackBar } from 'utils/Global';
import {
  selectIsEditable,
  selectIsModifyAccessRights,
} from 'redux/selectors/StateSelectors';
import { updateExperimentLayers } from 'redux/reducers/experimentDataReducer';
import {
  selectExperimentLayers,
  selectSelectedLayer,
} from 'redux/selectors/ExperimentStateSelector';
import { cloneDeep } from 'lodash';
import { useIsScreenInUse } from 'redux/hooks/common';
import { useAllowLayerEditing } from 'redux/hooks/experiment';

export default function RandomLayerExcludeIngredient({
  setContentView,
  setEditExcludeGroupId,
}: RandomLayerExcludeIngredientProps) {
  const [refresh, setRefresh] = useState(false);
  const _selectedLayer = useRMSelector(selectSelectedLayer);
  const experimentLayers = useRMSelector(selectExperimentLayers);
  const isEditMode: boolean = useRMSelector(selectIsEditable);
  const modifyAccessRights: boolean = useRMSelector(selectIsModifyAccessRights);
  const isScreenInUse: boolean = useIsScreenInUse();
  const isLayerEditingAllowed = useAllowLayerEditing();

  const dispatch = useRMDispatch();
  const setLayers = useCallback(
    (layers: LayerDTO[]) => dispatch(updateExperimentLayers(layers)),
    [dispatch],
  );
  const callPreserveUndoableState = usePreserveExperiment();

  function getIsExcludeActive() {
    const layerDetail = _selectedLayer.layerDetail as RandomLayerDTO;
    let totalIngCount = 0;
    layerDetail.randomLayerIngredientGroup.map(
      (rlig) => (totalIngCount += rlig.randomLayerGroupIngredient.length),
    );
    if (totalIngCount >= 2) {
      return true;
    }
    return false;
  }
  function deleteExcludeGroup(id) {
    const layers = cloneDeep(experimentLayers);
    const selectedLayer = layers.find((lyr) => lyr.id === _selectedLayer.id);
    const index = (
      selectedLayer.layerDetail as RandomLayerDTO
    ).randomLayerExcludeList.findIndex((e) => e.id === id);
    (selectedLayer.layerDetail as RandomLayerDTO).randomLayerExcludeList.splice(index, 1);
    selectedLayer.dirty = true;
    callPreserveUndoableState();
    setLayers(layers);
    setRefresh(!refresh);
    setEditExcludeGroupId(0);
  }

  function editExcludeGroup(id) {
    setEditExcludeGroupId(id);
    setContentView(ELayersView.EXCLUDEINGREDIENT);
  }

  function setIngredientsinGroupCard(group: RandomLayerExcludeListDTO, ings, pairNo) {
    return (
      <div id={`randomlayerexcludeingredient-inggroupcard-${ings}-wrapper`} className="group-card-excluded">
        <div id="randomlayerexcludeingredient-inggroupcardheader" className="groupDetailExcluded flex">
          <div id="randomlayerexcludeingredientinggroupcard-title-wrapper" className="w-75 flex">
            <input
              id='randomlayerexcludeingredient-inggroupcard-input'
              className="marginRight20 exclude-group-name"
              type="text"
              value={`Exclude Pair# ${pairNo}`}
            />
          </div>
          {isEditMode && modifyAccessRights && (
            <div id="randomlayerexcludeingredientinggroupcard-action-wrapper" className="flex ing-delete-update-enabled flex-space-between w-25">
              <Edit id="randomlayerexcludeingredientinggroupcard-edit" onClick={(e) => editExcludeGroup(group.id)} />
              <Delete id="randomlayerexcludeingredientinggroupcard-delete" onClick={(e) => deleteExcludeGroup(group.id)} />
            </div>
          )}
        </div>
        {ings}
      </div>
    );
  }
  function getExcludedGroups() {
    const layers = [...experimentLayers];
    const selectedLayer = layers.find((lyr) => lyr.id === _selectedLayer.id);
    if (
      (selectedLayer.layerDetail as RandomLayerDTO).randomLayerExcludeList.length === 0
    ) {
      return null;
    }
    const groups = [];
    (selectedLayer.layerDetail as RandomLayerDTO).randomLayerExcludeList.map(
      (excludeGroup, iter) => {
        const ings = [];
        ings.push(<RandomLayerExcludeIngredientCard ing={excludeGroup.ingredient1} />);
        ings.push(<RandomLayerExcludeIngredientCard ing={excludeGroup.ingredient2} />);
        groups.push(
          <div id="randomlayerexcludeingredientinggroupcard-excluadegroups-layers" className="flex w-100">
            {setIngredientsinGroupCard(excludeGroup, ings, iter + 1)}
          </div>,
        );
      },
    );
    return groups;
  }
  function onClickIng() {
    if (getIsExcludeActive()) {
      setContentView(ELayersView.EXCLUDEINGREDIENT);
    } else {
      showSnackBar(
        'There must be at least two ingredients in a layer in order to add an exclusion.',
      );
    }
  }
  return (
    <>
      <div id="randomlayerexcludeingredientinggroupcard-wrapper" className="flex flex-start excludeItems">
        <LayersHeading text="Exclude List Item" />{' '}
        {isEditMode && modifyAccessRights && !isScreenInUse && isLayerEditingAllowed && (
          <AddIngredient id="randomlayerexcludeingredientinggroupcard-adding" onClick={(e) => onClickIng()} />
        )}
      </div>
      <div id="randomlayerexcludeingredientinggroupcard-listcontainer" className="parent-excluded-groups">{getExcludedGroups()}</div>
    </>
  ); 
}
